import styled from "styled-components";

export const CMTooltip = styled.div(props => ({
    'svg': {
        cursor: 'pointer',
        marginTop: '-20px'
    },
    [`@media (min-width: 2000px)`]: {
    fontSize: '2vh',
    "& svg": {
      width:"2vh",
      height:"2vh"
    },
  },
}))